import { App, type URLOpenListenerEvent } from '@capacitor/app';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { navigateToDeepLink } from './navigateToDeepLink';
import { isNative } from '@/domains/shared/utils/native';

/**
 * Listens for Universal Links (iOS) / App Links (Android) opening the app and
 * routes them to the mapped feature. Mount once, high in the tree (see
 * `_app.tsx`). Renders nothing.
 *
 * Native only — on web the browser already handles the URL directly.
 */
const DeepLinkListener = () => {
  const router = useRouter();

  useEffect(() => {
    if (!isNative()) return;

    const handle = App.addListener(
      'appUrlOpen',
      (event: URLOpenListenerEvent) => {
        navigateToDeepLink(router, event.url);
      },
    );

    return () => {
      void handle.then((listener) => listener.remove());
    };
  }, [router]);

  return null;
};

export default DeepLinkListener;
